import striptags from 'striptags';

export const getTraducaoTrocaPor = (traducoes = [], trocapor, lingua = 'PT') => {

    lingua = lingua.toUpperCase();
    
    if(!traducoes.length){
        return trocapor;
    }

    const traducao = traducoes.filter(itens => {        
        return itens.trocarpor === trocapor;
    });

    const texto = ((traducao[0]&&traducao[0].extra&&traducao[0].extra.length)?traducao[0].extra[0]:traducao[0]);
    
    let result = '';
    if(texto){
        switch (lingua) {
            case 'EN':
                result = texto.ingles
                break;        
            case 'ES':
                result = texto.espanhol
                break;    
            default:            
                result = texto.portugues            
                break;
        }
    }else{
        result = trocapor;
    }
    return striptags(result!==null?result.replace(/&nbsp;/gi,''):'');
}

export const getCampoTraducao = (lingua) => {
    lingua = lingua.toUpperCase();
    let result = '';
    switch (lingua) {
        case 'EN':
            result = 'ingles';
            break;        
        case 'ES':
            result = 'espanhol';
            break;    
        default:            
            result = 'portugues';
            break;
    }
    return result;
}